"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: subscription/subscription-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fsubscription%2Fsubscription-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionServiceClient = exports.GetTopAvailableMerchantsResponse = exports.GetTopAvailableMerchantsRequest = exports.SearchKnotMerchantsResponse = exports.SearchKnotMerchantsRequest = exports.KnotSwitchCardResponse = exports.KnotSwitchCardRequest = exports.GetKnotPublicKeyResponse = exports.GetKnotPublicKeyRequest = exports.ExtendKnotSessionResponse = exports.ExtendKnotSessionRequest = exports.CreateKnotSessionResponse = exports.CreateKnotSessionRequest = exports.ListMerchantsInGroupsResponse = exports.ListMerchantsInGroupsRequest = exports.ListMerchantsResponse = exports.ListMerchantsRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const knot_1 = require("./knot");
const merchant_info_1 = require("./merchant-info");
const protobufPackage = 'com.step.subscription.proto';
function createBaseListMerchantsRequest() {
    return { forceRefresh: false };
}
exports.ListMerchantsRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.forceRefresh)) {
            message.forceRefresh = globalThis.Boolean(object.forceRefresh);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.forceRefresh !== undefined && message.forceRefresh !== false) {
            obj.forceRefresh = message.forceRefresh;
        }
        return obj;
    },
    create(base) {
        return exports.ListMerchantsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListMerchantsRequest();
        message.forceRefresh = object.forceRefresh ?? false;
        return message;
    },
};
function createBaseListMerchantsResponse() {
    return { merchants: [] };
}
exports.ListMerchantsResponse = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.merchants)) {
            message.merchants = object.merchants.map((e) => merchant_info_1.MerchantInfo.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchants?.length) {
            obj.merchants = message.merchants.map((e) => merchant_info_1.MerchantInfo.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ListMerchantsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListMerchantsResponse();
        message.merchants = object.merchants?.map((e) => merchant_info_1.MerchantInfo.fromPartial(e)) || [];
        return message;
    },
};
function createBaseListMerchantsInGroupsRequest() {
    return { forceRefresh: false };
}
exports.ListMerchantsInGroupsRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.forceRefresh)) {
            message.forceRefresh = globalThis.Boolean(object.forceRefresh);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.forceRefresh !== undefined && message.forceRefresh !== false) {
            obj.forceRefresh = message.forceRefresh;
        }
        return obj;
    },
    create(base) {
        return exports.ListMerchantsInGroupsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListMerchantsInGroupsRequest();
        message.forceRefresh = object.forceRefresh ?? false;
        return message;
    },
};
function createBaseListMerchantsInGroupsResponse() {
    return { groups: [] };
}
exports.ListMerchantsInGroupsResponse = {
    fromJSON(object) {
        const message = {
            groups: globalThis.Array.isArray(object?.groups)
                ? object.groups.map((e) => merchant_info_1.MerchantInfoGroup.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.groups?.length) {
            obj.groups = message.groups.map((e) => merchant_info_1.MerchantInfoGroup.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ListMerchantsInGroupsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListMerchantsInGroupsResponse();
        message.groups = object.groups?.map((e) => merchant_info_1.MerchantInfoGroup.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCreateKnotSessionRequest() {
    return {};
}
exports.CreateKnotSessionRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.CreateKnotSessionRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseCreateKnotSessionRequest();
        return message;
    },
};
function createBaseCreateKnotSessionResponse() {
    return { sessionId: '', clientId: '', cardId: '' };
}
exports.CreateKnotSessionResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.sessionId)) {
            message.sessionId = globalThis.String(object.sessionId);
        }
        if (isSet(object.clientId)) {
            message.clientId = globalThis.String(object.clientId);
        }
        if (isSet(object.cardId)) {
            message.cardId = globalThis.String(object.cardId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sessionId !== undefined && message.sessionId !== '') {
            obj.sessionId = message.sessionId;
        }
        if (message.clientId !== undefined && message.clientId !== '') {
            obj.clientId = message.clientId;
        }
        if (message.cardId !== undefined && message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        return obj;
    },
    create(base) {
        return exports.CreateKnotSessionResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateKnotSessionResponse();
        message.sessionId = object.sessionId ?? '';
        message.clientId = object.clientId ?? '';
        message.cardId = object.cardId ?? '';
        return message;
    },
};
function createBaseExtendKnotSessionRequest() {
    return { sessionId: '' };
}
exports.ExtendKnotSessionRequest = {
    fromJSON(object) {
        const message = {
            sessionId: isSet(object.sessionId) ? globalThis.String(object.sessionId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sessionId !== '') {
            obj.sessionId = message.sessionId;
        }
        return obj;
    },
    create(base) {
        return exports.ExtendKnotSessionRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseExtendKnotSessionRequest();
        message.sessionId = object.sessionId ?? '';
        return message;
    },
};
function createBaseExtendKnotSessionResponse() {
    return { sessionId: '' };
}
exports.ExtendKnotSessionResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.sessionId)) {
            message.sessionId = globalThis.String(object.sessionId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sessionId !== undefined && message.sessionId !== '') {
            obj.sessionId = message.sessionId;
        }
        return obj;
    },
    create(base) {
        return exports.ExtendKnotSessionResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseExtendKnotSessionResponse();
        message.sessionId = object.sessionId ?? '';
        return message;
    },
};
function createBaseGetKnotPublicKeyRequest() {
    return {};
}
exports.GetKnotPublicKeyRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetKnotPublicKeyRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetKnotPublicKeyRequest();
        return message;
    },
};
function createBaseGetKnotPublicKeyResponse() {
    return { key: '' };
}
exports.GetKnotPublicKeyResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.key)) {
            message.key = globalThis.String(object.key);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== undefined && message.key !== '') {
            obj.key = message.key;
        }
        return obj;
    },
    create(base) {
        return exports.GetKnotPublicKeyResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetKnotPublicKeyResponse();
        message.key = object.key ?? '';
        return message;
    },
};
function createBaseKnotSwitchCardRequest() {
    return { sessionId: '', jwePayload: '', taskId: '' };
}
exports.KnotSwitchCardRequest = {
    fromJSON(object) {
        const message = {
            sessionId: isSet(object.sessionId) ? globalThis.String(object.sessionId) : '',
            jwePayload: isSet(object.jwePayload) ? globalThis.String(object.jwePayload) : '',
            taskId: isSet(object.taskId) ? globalThis.String(object.taskId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sessionId !== '') {
            obj.sessionId = message.sessionId;
        }
        if (message.jwePayload !== '') {
            obj.jwePayload = message.jwePayload;
        }
        if (message.taskId !== '') {
            obj.taskId = message.taskId;
        }
        return obj;
    },
    create(base) {
        return exports.KnotSwitchCardRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseKnotSwitchCardRequest();
        message.sessionId = object.sessionId ?? '';
        message.jwePayload = object.jwePayload ?? '';
        message.taskId = object.taskId ?? '';
        return message;
    },
};
function createBaseKnotSwitchCardResponse() {
    return {};
}
exports.KnotSwitchCardResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.KnotSwitchCardResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseKnotSwitchCardResponse();
        return message;
    },
};
function createBaseSearchKnotMerchantsRequest() {
    return { query: '' };
}
exports.SearchKnotMerchantsRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.query)) {
            message.query = globalThis.String(object.query);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.query !== undefined && message.query !== '') {
            obj.query = message.query;
        }
        return obj;
    },
    create(base) {
        return exports.SearchKnotMerchantsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSearchKnotMerchantsRequest();
        message.query = object.query ?? '';
        return message;
    },
};
function createBaseSearchKnotMerchantsResponse() {
    return { merchants: [], groups: [] };
}
exports.SearchKnotMerchantsResponse = {
    fromJSON(object) {
        const message = {
            groups: globalThis.Array.isArray(object?.groups)
                ? object.groups.map((e) => knot_1.MerchantGroup.fromJSON(e))
                : [],
        };
        if (globalThis.Array.isArray(object?.merchants)) {
            message.merchants = object.merchants.map((e) => knot_1.KnotMerchant.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchants?.length) {
            obj.merchants = message.merchants.map((e) => knot_1.KnotMerchant.toJSON(e));
        }
        if (message.groups?.length) {
            obj.groups = message.groups.map((e) => knot_1.MerchantGroup.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.SearchKnotMerchantsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSearchKnotMerchantsResponse();
        message.merchants = object.merchants?.map((e) => knot_1.KnotMerchant.fromPartial(e)) || [];
        message.groups = object.groups?.map((e) => knot_1.MerchantGroup.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetTopAvailableMerchantsRequest() {
    return {};
}
exports.GetTopAvailableMerchantsRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetTopAvailableMerchantsRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetTopAvailableMerchantsRequest();
        return message;
    },
};
function createBaseGetTopAvailableMerchantsResponse() {
    return { merchants: [] };
}
exports.GetTopAvailableMerchantsResponse = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.merchants)) {
            message.merchants = object.merchants.map((e) => knot_1.KnotMerchant.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchants?.length) {
            obj.merchants = message.merchants.map((e) => knot_1.KnotMerchant.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetTopAvailableMerchantsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTopAvailableMerchantsResponse();
        message.merchants = object.merchants?.map((e) => knot_1.KnotMerchant.fromPartial(e)) || [];
        return message;
    },
};
/**
 * Subscription Service API.
 */
class SubscriptionServiceClient {
    rpc;
    name = 'com.step.subscription.proto.SubscriptionService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/subscription';
    methods = [{
            name: 'ListMerchants',
            requestType: exports.ListMerchantsRequest,
            responseType: exports.ListMerchantsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'ListMerchantsInGroups',
            requestType: exports.ListMerchantsInGroupsRequest,
            responseType: exports.ListMerchantsInGroupsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'CreateKnotSession',
            requestType: exports.CreateKnotSessionRequest,
            responseType: exports.CreateKnotSessionResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'ExtendKnotSession',
            requestType: exports.ExtendKnotSessionRequest,
            responseType: exports.ExtendKnotSessionResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetKnotPublicKey',
            requestType: exports.GetKnotPublicKeyRequest,
            responseType: exports.GetKnotPublicKeyResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'KnotSwitchCard',
            requestType: exports.KnotSwitchCardRequest,
            responseType: exports.KnotSwitchCardResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'SearchKnotMerchants',
            requestType: exports.SearchKnotMerchantsRequest,
            responseType: exports.SearchKnotMerchantsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetTopAvailableMerchants',
            requestType: exports.GetTopAvailableMerchantsRequest,
            responseType: exports.GetTopAvailableMerchantsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * List user's merchants that are blocked, have online transactions, or are enrolled via Knot.
     */
    listMerchants(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Same as ListMerchants above, but the response contains groups of merchants rather than
     * a flat merchant list.
     */
    listMerchantsInGroups(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Creates a Knot session.
     */
    createKnotSession(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Extends Knot session by 30 minutes.
     */
    extendKnotSession(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Gets Knot public key associated with Step. They key is used on the client to encrypt
     * card data which is then submitted via KnotSwitchCard rpc method below.
     */
    getKnotPublicKey(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Triggers Knot to perform the card switch for the merchant authenticated by user using
     * the Knot client SDK.
     */
    knotSwitchCard(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Searches for Knot-supported merchant via their API.
     */
    searchKnotMerchants(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns a list of top 3 most popular merchants that the user hasn't added yet.
     */
    getTopAvailableMerchants(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[7],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.SubscriptionServiceClient = SubscriptionServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=subscription-service.js.map